import { CLINIC } from "../lib/api";

const WHATSAPP_ICON = "https://customer-assets.emergentagent.com/job_clinica-calafell-v2/artifacts/ffiktm07_boton%20whatsapp%20%281%29.jpg";

export default function WhatsAppFloat() {
  const message = encodeURIComponent(
    "Hola, me gustaría pedir información sobre una cita en Clínica Dental Pina."
  );
  const url = `https://wa.me/${CLINIC.whatsapp}?text=${message}`;

  const handleClick = (e) => {
    e.preventDefault();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <a
      href={url}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-24 right-6 z-[9999] group flex items-center gap-3 cursor-pointer"
    >
      <span className="hidden group-hover:block bg-white text-slate-700 text-xs font-medium px-3.5 py-1.5 rounded-full shadow-md border border-slate-200 whitespace-nowrap pointer-events-none">
        WhatsApp
      </span>
      <img
        src={WHATSAPP_ICON}
        alt="WhatsApp"
        className="w-14 h-14 rounded-full shadow-lg hover:scale-105 transition-transform pointer-events-none object-cover"
      />
    </a>
  );
}
